
import React, { useState , useEffect , useContext , lazy, Suspense  } from "react";
import { Link, NavLink } from "react-router-dom";
import QuickBuyItem from "./QuickBuyItem";
import { HomeContext } from "../Home";
import  { loaderBar , apibaseURl , currencySymbol }  from "../../functions/Function";


const QuickBuy = (props) => {
const HomeContextData = useContext(HomeContext);
  const [data, setData] = useState([]);
  const [isloader, setIsloader] = useState(true);
  
  const timer = () =>{
    setTimeout(() => {
    setIsloader(false);
  }, 1000);
} 
  const fetchData = () => {
    fetch(apibaseURl + "quickbuy")
      .then(res => res.json())
      .then((result) => {
        if (result.result == true) {
            
            setData(result.response);
            if(result.response[0].id)
            {
                HomeContextData.handleClickActiveProduct(result.response[0].id)
            }else
            {
                HomeContextData.handleClickActiveProduct(0);
            }
            timer()
        }
      }
      )
  }



  useEffect(() => {
    fetchData();
    //props.handleClickActiveProduct(data[0]);
  }, [])
    return (
        
        <>  
            {props.active == 'quick' ? 
                <div>
                     <form>
                            <input className="form-control serch-middle-left" type="search" placeholder="Search"
                            aria-label="Search" />
                    </form>
                    <div className="tab-content" id="nav-tabContent">
                        <div className="middle-left-content">
                            <div><small><b>Product Name</b></small></div>
                            <div><small><b>Price /  {currencySymbol()} </b></small></div>
                        </div>

                        <div className="tab-pane fade show active" id="nav-quick" role="tabpanel"
                            aria-labelledby="nav-favourite-tab">
                            {isloader == true && loaderBar(300 , 25) }
                            {isloader == false &&
                            <ul className="ivo-left-index-ul scroll-bar">
                            
                                {data.length > 0 ? data.map((row, i) => (
                                    <>
                                        <QuickBuyItem key={i} product={row}  handleClickActiveProduct={props.handleClickActiveProduct} />
                                    </>
                                    
                                )) :

                                   ''
                                }

                            </ul>
                            }

                        </div>

                    </div>
                </div>
            
            : ''}
           
        </>
       

    );
}

export default QuickBuy;
